export const getPreferredSeoIdentifer = (url, locale) => {
  const isDomainLocale = ['en', 'en-CA', 'en-AU', 'en-GB', 'zh'].includes(
    locale,
  );
  const preferredUrl = isDomainLocale ? url : `/${locale}${url}`;
  return preferredUrl;
};
